import React from "react";
import { Link } from "react-router-dom";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import StatusView from "@udok/lib/components/UserStatus/StatusView";
import { useGetClientsStatus } from "hooks/socket";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    itemUserStatus: {
      position: "absolute",
      bottom: "25%",
      left: theme.spacing(3),
    },
  })
);

export type ItemComponentProps = {
  userID: string;
  onClick?: (userID: string) => void;
  useLink?: boolean;
} & any;

const ItemComponent = (props: ItemComponentProps) => {
  const { userID, onClick } = props;
  const [status] = useGetClientsStatus(userID);
  const classes = useStyles();

  const handlePress = () => {
    onClick?.(userID);
  };

  const children = (
    <>
      {props.children}
      <StatusView
        size="small"
        classes={{
          root: classes.itemUserStatus,
        }}
        status={Boolean(status)}
      />
    </>
  );
  if (onClick) {
    return (
      <div {...props} style={{ paddingRight: 85 }} onClick={handlePress}>
        {children}
      </div>
    );
  }
  return (
    <Link {...props} style={{ paddingRight: 85 }}>
      {children}
    </Link>
  );
};

export default ItemComponent;
